{
  "userSettings": {
    "title": "Mes paramètres",
    "description": "Gérez votre profil personnel et vos préférences",
    "tabs": {
      "profile": "Profil",
      "preferences": "Préférences",
      "security": "Sécurité"
    },
    "profile": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "E-mail",
      "emailHelper": "Contactez votre responsable d'organisation pour modifier votre e-mail",
      "role": "Intitulé du poste",
      "roleHelper": "Contactez votre responsable d'organisation pour modifier l'intitulé de votre poste",
      "department": "Département",
      "departmentHelper": "Contactez votre responsable d'organisation pour modifier votre département",
      "status": "Statut du compte",
      "organizationInfo": "Informations sur l'organisation",
      "updateSuccess": "Profil mis à jour avec succès",
      "updateError": "Échec de la mise à jour du profil"
    },
    "preferences": {
      "language": "Langue",
      "languageHelper": "Choisissez votre langue préférée pour l'interface"
    },
    "security": {
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmPassword": "Confirmer le nouveau mot de passe",
      "changePassword": "Changer le mot de passe",
      "passwordSuccess": "Mot de passe changé avec succès",
      "passwordError": "Échec du changement de mot de passe",
      "invalidCurrentPassword": "Le mot de passe actuel est incorrect",
      "passwordRequirements": "Exigences du mot de passe",
      "minLength": "Au moins 8 caractères",
      "requireLowercase": "Au moins une lettre minuscule (a-z)",
      "requireUppercase": "Au moins une lettre majuscule (A-Z)",
      "requireNumber": "Au moins un chiffre (0-9)",
      "twoFactorTitle": "Authentification à deux facteurs (2FA)",
      "twoFactorDescription": "Protégez votre compte avec un code à usage unique généré par une application d'authentification.",
      "twoFactorEnabled": "L'authentification à deux facteurs est active",
      "setupTwoFactor": "Configurer la 2FA",
      "scanQrCode": "Scannez ce code QR avec votre application d'authentification, puis saisissez le code à 6 chiffres ci-dessous.",
      "manualSecret": "Impossible de scanner ? Afficher la clé secrète pour une saisie manuelle",
      "codeLabel": "Code à 6 chiffres",
      "verifyCode": "Vérifier le code",
      "removeTwoFactor": "Supprimer la 2FA",
      "removeTwoFactorConfirm": "Votre compte ne demandera plus de code à usage unique à la connexion. Êtes-vous sûr ?",
      "twoFactorSetupSuccess": "Authentification à deux facteurs activée",
      "twoFactorSetupError": "Échec de la configuration de l'authentification à deux facteurs",
      "twoFactorRemoveSuccess": "Authentification à deux facteurs supprimée",
      "twoFactorRemoveError": "Échec de la suppression de l'authentification à deux facteurs",
      "ssoManagedTitle": "Géré par votre organisation",
      "ssoManagedDescription": "Votre mot de passe et votre authentification à deux facteurs sont gérés par {{idpName}}.",
      "ssoManagedFallbackIdp": "le fournisseur d'identité de votre organisation",
      "passwordUnavailable": "Le changement de mot de passe n'est pas encore disponible pour votre compte. Connectez-vous une fois via l'authentification unique ou contactez votre administrateur.",
      "noPasswordSet": "Aucun mot de passe n'est défini pour ce compte. Il n'y a donc aucun mot de passe à modifier.",
      "statusError": "Impossible de charger les paramètres de sécurité.",
      "passkeysTitle": "Clés d'accès (passkeys)",
      "passkeysDescription": "Connectez-vous sans mot de passe avec Face ID, Touch ID ou une clé de sécurité matérielle.",
      "addPasskey": "Ajouter une clé d'accès",
      "unnamedPasskey": "Clé d'accès",
      "removePasskey": "Supprimer la clé d'accès",
      "removePasskeyConfirm": "Cette clé d'accès ne pourra plus être utilisée pour la connexion. Êtes-vous sûr ?",
      "passkeyRemoveSuccess": "Clé d'accès supprimée",
      "passkeyRemoveError": "La suppression de la clé d'accès a échoué",
      "reauthenticate": "Confirmer la connexion",
      "passkeyLinkError": "Le démarrage de la configuration de la clé d'accès a échoué",
      "passkeyPopupBlocked": "Votre navigateur a bloqué l'onglet de configuration de la clé d'accès. Veuillez autoriser les fenêtres pop-up pour cette page et réessayer.",
      "stepUpTitle": "Connexion récente requise",
      "stepUpDescription": "Pour votre sécurité, la modification des paramètres de connexion nécessite une connexion récente. Vous serez redirigé pour confirmer votre connexion, puis ramené ici.",
      "stepUpPasskeyDescription": "Pour votre sécurité, l'ajout d'une clé d'accès nécessite une connexion récente. Après avoir confirmé votre connexion, cliquez à nouveau sur « Ajouter une clé d'accès ».",
      "stepUpSignInAgain": "Pour votre sécurité, cette modification nécessite une connexion récente. Veuillez vous déconnecter, vous reconnecter, puis réessayer."
    }
  },
  "adminSettings": {
    "tenant": {
      "tabUsers": "Utilisateurs",
      "tabSettings": "Paramètres",
      "slug": "Identifiant : {{slug}}",
      "addUser": "Ajouter un utilisateur",
      "columnName": "Nom",
      "columnEmail": "E-mail",
      "columnUserTypes": "Types d'utilisateur",
      "columnStatus": "Statut",
      "columnClassification": "Classification",
      "sendInvitationAction": "Envoyer l'invitation",
      "resendInvitationAction": "Renvoyer l'invitation",
      "copyActivationLinkAction": "Copier le lien d'activation",
      "copyActivationLinkSuccess": "Lien d'activation copié dans le presse-papiers",
      "copyActivationLinkFailed": "Échec de la génération du lien d'activation",
      "copyActivationLinkManual": "Copiez ce lien d'activation manuellement",
      "resetSignInFailed": "Échec de la réinitialisation des identifiants de connexion",
      "deleteUserTitle": "Supprimer l'utilisateur",
      "deleteUserDescription": "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",
      "deleteUserSuccess": "Utilisateur supprimé avec succès",
      "deleteUserFailed": "Échec de la suppression de l'utilisateur",
      "sendInvitationSuccess": "Invitation envoyée avec succès",
      "sendInvitationFailed": "Échec de l'envoi de l'invitation",
      "createdButInvitationFailed": "Utilisateur créé, mais l'invitation n'a pas pu être envoyée — utilisez « Renvoyer l'invitation »",
      "externalOrgRequired": "L'organisation externe est requise pour les utilisateurs externes",
      "aiTitle": "Fonctionnalités IA",
      "aiDescription": "Contrôlez la disponibilité des fonctionnalités IA pour ce locataire.",
      "enableAILabel": "Activer l'IA",
      "enableAIDescription": "Interrupteur principal pour toutes les fonctionnalités IA de ce locataire, comme Bliksy, le résumé d'étape et la dictée. S'applique aux locataires clients et partenaires.",
      "saved": "Paramètres du locataire enregistrés.",
      "saveFailed": "Échec de l'enregistrement des paramètres du locataire.",
      "tabApps": "Applications",
      "tabUsage": "Utilisation",
      "appsDescription": "Gérez les applications dont dispose ce locataire.",
      "addAppSuccess": "Application ajoutée avec succès.",
      "addAppFailed": "Échec de l'ajout de l'application.",
      "removeAppSuccess": "Application supprimée avec succès.",
      "removeAppFailed": "Échec de la suppression de l'application.",
      "addApp": "Ajouter une application",
      "addAppNoCandidates": "Aucune autre application n'est disponible à l'ajout.",
      "noAppsAdded": "Aucune application n'a encore été ajoutée à ce locataire.",
      "appAllowed": "Peut utiliser cette application",
      "appAllowedSaved": "Autorisation enregistrée.",
      "appAllowedSaveFailed": "Échec de l'enregistrement de l'autorisation.",
      "appSeats": "Sièges",
      "appSeatLimit": "Limite de sièges",
      "seatLimitSaved": "Limite de sièges enregistrée.",
      "seatLimitSaveFailed": "Échec de l'enregistrement de la limite de sièges.",
      "removeAppTitle": "Supprimer l'application",
      "removeAppConfirm": "La suppression de cette application supprime sa configuration propre au locataire et libère tous les sièges attribués. Un nouvel ajout ne les restaure pas.",
      "removeApp": "Retirer du locataire",
      "appConfig": "Configuration",
      "appConfigPlannerEnabled": "Planificateur de projet de mesure",
      "appConfigSalesPartnerCompanyId": "Entreprise HubSpot du partenaire",
      "appConfigSalesPartnerCompanyIdHint": "Le partenaire ne voit que les leads apportés par les collaborateurs de cette entreprise. Géré sur le tenant, pas ici.",
      "appConfigSalesPartnerCompanyIdMissing": "Aucune entreprise HubSpot n'est liée à ce tenant : le partenaire ne voit aucun lead et ne peut en signaler aucun. À définir dans l'onglet Général.",
      "appConfigUnreadable": "La configuration enregistrée est illisible ; l'enregistrement la remplace.",
      "appConfigure": "Configurer",
      "appConfigTitle": "Configuration de l'application",
      "appConfigUnreadableDialog": "Une configuration enregistrée existe, mais elle ne peut pas être lue avec le schéma actuel. Elle n'est pas affichée ici et l'enregistrement la remplace.",
      "appConfigNorms": "Normes",
      "appConfigNormsPlaceholder": "Sélectionner des normes",
      "appConfigRequestAllowance": "Requests par année contractuelle",
      "appConfigContractAnchor": "Début du contrat",
      "appConfigContractAnchorPick": "Choisir une date",
      "appConfigContractAnchorPopup": "Calendrier du début du contrat",
      "appConfigContractAnchorFuture": "Le début du contrat ne peut pas être dans le futur.",
      "appConfigSaved": "Configuration enregistrée.",
      "appConfigSaveFailed": "L'enregistrement de la configuration a échoué.",
      "provisioningTitle": "Créer des espaces de travail pour d'autres",
      "provisioningDescription": "Les types d'espaces de travail que ce partenaire peut créer pour d'autres puis gérer, par ex. depuis l'application commerciale. Sans sélection, il ne peut en créer aucun."
    },
    "globalAi": {
      "title": "Paramètres des modèles IA",
      "description": "Configurez les modèles IA utilisés pour tous les locataires.",
      "highModelLabel": "Modèle haut niveau",
      "highModelDescription": "Modèle IA utilisé pour les tâches complexes (agent Bliksy, Omniscient).",
      "lowModelLabel": "Modèle bas niveau",
      "lowModelDescription": "Modèle IA utilisé pour les tâches simples (résumés d'étapes, sous-tâches Bliksy).",
      "transcriptionModelLabel": "Modèle de transcription",
      "transcriptionModelDescription": "Modèle utilisé pour la transcription voix-texte.",
      "saved": "Paramètres des modèles IA enregistrés.",
      "saveFailed": "Échec de l'enregistrement des paramètres des modèles IA.",
      "featureOverride": {
        "title": "Remplacements par fonctionnalité",
        "description": "Vous pouvez éventuellement épingler une fonctionnalité à un modèle ou un palier spécifique. Par défaut, chaque fonctionnalité suit le palier qui lui est attribué.",
        "tier": {
          "high": "Palier haut",
          "low": "Palier bas",
          "decision": "Palier de décision"
        },
        "bliksy-chat": {
          "label": "Chat Bliksy",
          "description": "Agent assistant d'enregistrement interactif."
        },
        "bliksy-modify-subagent": {
          "label": "Sous-agent de modification Bliksy",
          "description": "Sous-agent qui applique les modifications structurées des étapes dans Bliksy."
        },
        "step-summary": {
          "label": "Résumé d'étape",
          "description": "Génère les noms et descriptions d'étape après la fin d'un enregistrement."
        },
        "chat-title": {
          "label": "Génération de titre de conversation",
          "description": "Génère de courts titres pour les sessions de conversation."
        },
        "chat-summarizer": {
          "label": "Résumé de conversation",
          "description": "Condense les longues conversations en un résumé évolutif."
        },
        "decision-eval-judge": {
          "label": "Juge de décision (évaluations)",
          "description": "Note les exécutions d'évaluation à l'aide de questions graduées."
        }
      },
      "appOverride": {
        "title": "Modèles des applications"
      },
      "reasoning": {
        "label": "Effort de raisonnement",
        "effort": {
          "none": "Désactivé",
          "low": "Faible",
          "medium": "Moyen",
          "high": "Élevé",
          "xhigh": "Très élevé",
          "max": "Maximal"
        }
      }
    },
    "superAdmin": {
      "title": "Gestion des utilisateurs",
      "description": "Gérer les utilisateurs superadmin du système",
      "inviteUser": "Inviter un utilisateur",
      "errorLoadingUsers": "Erreur lors du chargement des utilisateurs",
      "columnEmail": "E-mail",
      "columnFirstName": "Prénom",
      "columnLastName": "Nom",
      "columnStatus": "Statut",
      "columnInvited": "Invité",
      "columnActivated": "Activé",
      "inviteTitle": "Inviter un utilisateur SuperAdmin",
      "inviteDescription": "Envoyez une invitation à un nouvel utilisateur superadmin. Il recevra un e-mail avec les instructions pour activer son compte.",
      "inviteSend": "Envoyer l'invitation",
      "firstNameRequired": "Le prénom est requis",
      "lastNameRequired": "Le nom est requis",
      "emailRequired": "L'e-mail est requis",
      "emailInvalid": "Adresse e-mail invalide",
      "role": "Rôle",
      "roles": {
        "platform_admin": "Administration de la plateforme",
        "platform_support": "Support"
      },
      "roleHint": {
        "platform_admin": "Peut tout faire : catalogue, utilisateurs, paramètres, suppression.",
        "platform_support": "Lit les comptes, la liste des espaces de travail et les journaux — ne modifie rien."
      },
      "roleNone": "Aucun rôle",
      "noAccessTitle": "Aucun domaine activé",
      "noAccessBody": "Ce compte appartient à la plateforme mais ne porte aucun rôle. Un administrateur peut lui en attribuer un dans la gestion des utilisateurs.",
      "rolePlaceholder": "Choisir un rôle",
      "roleRequired": "Veuillez choisir un rôle.",
      "changeRole": "Modifier le rôle",
      "changeRoleTitle": "Modifier le rôle",
      "changeRoleDescription": "Ce que {{name}} peut faire sur la plateforme.",
      "changeRoleSave": "Enregistrer"
    }
  }
}
